@if (confirmationData$ | async; as confirmationData) {
  <div class="row" class="row margin-top-30">
    <ds-confirmation [confirmationData]="confirmationData">
      <div class="margin-top-20">
        <a href="#" [routerLink]="['/overview']">Back to Overview</a>
      </div>
    </ds-confirmation>
  </div>
}
